import React from "react";
import DOMPurify from 'dompurify';

interface BlogPreviewProps {
    content: string;
}

const BlogPreview: React.FC<BlogPreviewProps> = ({ content }) => {
    return (
        <div className="blog-preview" style={{padding: "20px", borderRadius: "10px"}}>
            <div
                id="single-entry-content"
                className="prose dark:prose-invert prose-sm !max-w-screen-md sm:prose lg:prose-lg mx-auto dark:prose-dark"
                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content, { ADD_TAGS: ['iframe'], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder'] })}}
            >
            </div>
        </div>
    );
};

export default BlogPreview;
